import qs from "qs";

export const getQueryParams = () => {
  return qs.parse(window.location.search.substring(1));
};
